
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { scrollWatcher } from '~/helpers/scroll-watcher.js';
import { homePageWatcher } from "~/helpers/is-main-page";


export default BaseCmsBlock.extend({
  name: "StatisticsBlock",

  data: function () {
    return {
      isAnimate: false,
    }
  },

  components: {
    StatisticItem: () => import("./components/StatisticsBlock/StatisticItem")
  },

  mounted: function () {
    document.addEventListener('scroll', this.inFieldOfView)
  },

  unMounted: function () {
    document.removeEventListener('scroll', this.inFieldOfView)
  },

  computed: {
    isHome: function () {
      if (!process.client) {
        return
      }
      return homePageWatcher()
    }
  },

  methods: {
    inFieldOfView: function () {
      if (scrollWatcher('statistics-block__content')) {
        document.removeEventListener('scroll', this.inFieldOfView);
        this.isAnimate = true;
      }
    },
  },
})
